export default "__VITE_ASSET__B2Cjrz6v__"